import { SupportedBlockchainsModel, OverviewModel } from '../../constants/DataModels'
import {
  RequestSupportedBlockchainData,
  SetSupportedBlockchainsData,
  RequestOverviewData,
  SetOverviewData,
  SetDayRelay,
} from './StatsTypes'

export enum StatsActionTypes {
  REQUEST_SUPPORTED_BLOCKCHAINS_DATA = 'REQUEST_SUPPORTED_BLOCKCHAINS_DATA',
  SET_SUPPORTED_BLOCKCHAINS_DATA = 'SET_SUPPORTED_BLOCKCHAINS_DATA',
  REQUEST_OVERVIEW_DATA = 'REQUEST_OVERVIEW_DATA',
  SET_OVERVIEW_DATA = 'SET_OVERVIEW_DATA',
  SET_DAY_RELAY = 'SET_DAY_RELAY',
}

export const requestSupportedBlockchainData = (): RequestSupportedBlockchainData => {
  return {
    type: StatsActionTypes.REQUEST_SUPPORTED_BLOCKCHAINS_DATA,
  }
}

export const setSupportedBlockchainsData = (data: SupportedBlockchainsModel): SetSupportedBlockchainsData => {
  return {
    type: StatsActionTypes.SET_SUPPORTED_BLOCKCHAINS_DATA,
    payload: data,
  }
}

export const requestOverviewData = (): RequestOverviewData => {
  return {
    type: StatsActionTypes.REQUEST_OVERVIEW_DATA,
  }
}

export const setOverviewData = (data: OverviewModel): SetOverviewData => {
  return {
    type: StatsActionTypes.SET_OVERVIEW_DATA,
    payload: data,
  }
}

export const setDayRelay = (data: number): SetDayRelay => {
  return {
    type: StatsActionTypes.SET_DAY_RELAY,
    payload: data,
  }
}

